import './App.css';

import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';


import Home from "./components/pages/Home";
import ProductPage from './components/pages/ProductPage';
import Footer from './components/inc/Footer';
import About from './components/pages/About';
import Contact from './components/pages/Contact';
import Medicine from './components/pages/Medicine';
import LysorichSyrup from './components/pages/LysorichSyrup';
import LysorichGold from './components/pages/LysorichGold';
import Kidccd3 from './components/pages/Kidccd3';
import Kidccforte from './components/pages/Kidccforte';

function App() {
  return (
      <Router>
   
    <div>
      
      <Routes>

      <Route axact path="/" element={<Home/>}/>
      
      <Route axact path="/gallery" element={<ProductPage/>}/>
          <Route axact path="/about" element={<About/>}/>
          <Route axact path="/Contact" element={<Contact/>}/>
          <Route axact path="/LysorichSyrup" element={<LysorichSyrup/>}/>
          <Route axact path="/LysorichGold" element={<LysorichGold/>}/>
                   <Route axact path="/products" element={<Medicine/>}/>
                     <Route axact path="/Kidccd3" element={<Kidccd3/>}/>
                            <Route axact path="/Kidccd3forte" element={<Kidccforte/>}/>
         </Routes>
    <Footer/>
  
    </div>

    </Router>
  );
}

export default App;
